var map = {
	"./about-us.svg": 757,
	"./betting-icon.svg": 758,
	"./bonus.svg": 759,
	"./coin.svg": 760,
	"./contact-us.svg": 761,
	"./download-app.svg": 762,
	"./edit-btn.svg": 763,
	"./feedback.svg": 764,
	"./global.svg": 765,
	"./info-centre.svg": 766,
	"./instant-rebate.svg": 767,
	"./mall-icon.svg": 768,
	"./message.svg": 769,
	"./personal-info-edit.svg": 770,
	"./r77-coin.svg": 771,
	"./r77-rewards.svg": 772,
	"./redemption-icon.svg": 773,
	"./referral.svg": 774,
	"./resp-gaming.svg": 775,
	"./security.svg": 776,
	"./transaction-icon.svg": 777,
	"./vip-icon.svg": 778,
	"./wallet-icon.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;